import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { AccountsControllerService, CustomerControllerService, MastersControllerService, PlaidControllerService } from './generated/services';
import { RoleService } from './role.service';
import { CreditCardApplicationControllerService } from './generated/services/credit-card-application-controller.service';
import { CommonService } from './common.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CreditCardUiIntegrationService {

  constructor(private http: HttpClient,
    private AccountsControllerService: AccountsControllerService,
    private CustomerControllerService: CustomerControllerService,
    private PlaidControllerService: PlaidControllerService,
    private MastersControllerService: MastersControllerService,
    private roleService: RoleService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private CreditCardApplicationControllerService: CreditCardApplicationControllerService,
    private CommonService:CommonService
  ) { }


  getCreditCardAccessTokenWithCode(code: any) {
    const payload = {
      "grant_type": "authorization_code",
      "code": code,
      "client_id": environment.creditCardInformation.client_id,
      "client_secret": environment.creditCardInformation.client_secret,
      "redirect_uri": environment.creditCardInformation.redirect_uri,
    }
    const reponse =  this.http.post(environment.creditCardInformation.client_auth_url+"/oauth/token", payload);
    reponse.subscribe((resp: any) => {
      console.log('resp', resp);
      if (resp?.access_token) {
        this.roleService.setRoles('credit_card_code', code);
        this.roleService.setRoles('credit_card_refresh_token', resp?.refresh_token);
        // sessionStorage.setItem('creditCardAccessToken', resp?.access_token);
        // sessionStorage.setItem('creditCardRefreshToken', resp?.refresh_token);
      }
    }, (error: any) => {
      console.log('error', error);
    });
  }

  async getCreditCardAccessTokenWithRefreshToken() {
    const code = this.roleService.getRoles('credit_card_code');
    const refresh_token = this.roleService.getRoles('credit_card_refresh_token');

    console.log('code', code);
    console.log('refresh_token', refresh_token);
    
    const payload = {
      "grant_type": "refresh_token",
      "code": code,
      "client_id": environment.creditCardInformation.client_id,
      "client_secret": environment.creditCardInformation.client_secret,
      "redirect_uri": environment.creditCardInformation.redirect_uri,
      "refresh_token": refresh_token,
    }
    // const reponse =  this.http.post("https://auth.credit.supers.am/oauth/token", payload);
    // reponse.subscribe((resp: any) => {
    //   console.log('resp', resp);
    //   if (resp?.access_token) {
    //     this.roleService.setRoles('credit_card_refresh_token', resp?.refresh_token);
    //     return resp?.access_token;
    //     // sessionStorage.setItem('creditCardAccessToken', resp?.access_token);
    //     // sessionStorage.setItem('creditCardRefreshToken', resp?.refresh_token);
    //   } else {
    //     return null;
    //   }
    // }, (error: any) => {
    //   console.log('error', error);
    //   return null;
    // });
    try {
      const response: any = await firstValueFrom(
        this.http.post(environment.creditCardInformation.client_auth_url+"/oauth/token", payload)
      );
      console.log('resp', response);
      if (response?.access_token) {
        this.roleService.setRoles('credit_card_refresh_token', response?.refresh_token);
        return response?.access_token;
      } else {
        return null;
      }
    } catch (error: any) {
      console.log('error', error);
      return null;
    }
  }


  async clientGraphQlQuery(payload: any){
    // const payload = {
    //   "query": "query listCardTransactions($cardId: String!, $from: String!, $to: String!, $limit: Int!, $offset: Int!, $search: String) {\n  listCardTransactions(\n    filters: {\n      cardId: $cardId\n      dateRange: { from: $from, to: $to }\n      pagination: { limit: $limit, offset: $offset }\n      search: $search\n    }\n  ) {\n    dateRange {\n      count\n      from\n      to\n    }\n    pagination {\n      limit\n      offset\n      count\n    }\n    nodes {\n      id\n      accountId\n amount\n     autopayReward { points\n }\n      cardId\n      category\n      date\n      description\n      documents { id\n }\n      isVendorOffer\n      merchantGroup { category\n logoUrl\n name }\n      merchantId\n      merchantName\n      note\n      reward { points\n }\n      status\n      type\n      vendorOffers { vendorName\n vendorOfferId }\n    }\n  }\n}",
    //   "variables": {
    //     "cardId": "56df8104-95ef-48bf-9e56-acf46d3aece5",
    //     "from": "2024-01-01",
    //     "to": "2025-12-31",
    //     "limit": 20,
    //     "offset": 0,
    //     "search": ""
    //   }
    // }

    const access_token = await this.getCreditCardAccessTokenWithRefreshToken();
    if (!access_token) {
      throw new Error('Failed to retrieve access token');
    }
    return this.http.post(
      environment.creditCardInformation.client_graphql_url+"/graphql",
      payload,
      {
        headers: {
          'X-Skip-JWT': 'true',
          Authorization: 'Bearer '+access_token 
        }
      }
    ); 
  }

  async downloadCreditCardStatement(statementId: any) {
    const access_token = await this.getCreditCardAccessTokenWithRefreshToken();
    if (!access_token) {
      throw new Error('Failed to retrieve access token');
    }
    return this.http.get(
      `${environment.creditCardInformation.client_graphql_url}/statements/${statementId}/pdf`,
      {
        responseType: "blob",
        headers: {
          'X-Skip-JWT': 'true',
          Authorization: 'Bearer '+access_token 
        }
      }
    );
  }

  openWindow(resp: any){
    const  URL = window.URL.createObjectURL(resp)
    const w = window.open('', '_blank');
              if (w) {
                w.document.write(`
            <html>
            <head><title>Document</title></head>
            <body style="margin:0;padding:0;">
            <iframe src="${URL}" width="100%" height="100%" style="border: none;"></iframe>
            </body>
            </html>
            `);
              } 
  }

  downloadPDF(response:any, name:any){
    const url = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
  }
}
